export default "__VITE_ASSET__DJQvnF30__"